import React from 'react';
import { AwardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-background py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-139" data-mp="1j9qpghfdfsh6">
      <div className="mx-auto max-w-3xl px-4" data-id="element-140" data-mp="1na0r5hw4rwq8">
        <SectionHeading id="pricing-title" data-id="element-141" data-mp="1s9dh4biatjx1">Choose Your Option</SectionHeading>

        <article className="mt-10 overflow-hidden rounded-3xl border-2 border-electric bg-surface shadow-glow-strong" data-id="element-142" data-mp="1sbgh9od60tfh">
          <div className="border-b border-electric/30 bg-background/40 px-6 py-4 sm:px-10" data-id="element-143" data-mp="227jf4i0zi5wm">
            <span className="inline-flex items-center gap-2 rounded-full bg-gold px-3 py-1.5 font-display text-sm font-extrabold uppercase tracking-[.14em] text-background" data-id="element-144" data-mp="2uyupxur694p">
              <AwardIcon className="h-4 w-4" aria-hidden="true" data-id="element-145" data-mp="7vwdocnl7779" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-146" data-mp="1mihpj2feyfy5">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-147" data-mp="1hpoksejy37m2">
              <div data-id="element-148" data-mp="1cq3ko0t1gt7r">
                <h3 className="font-display text-3xl font-bold leading-tight tracking-tight text-foreground sm:text-4xl" data-id="element-149" data-mp="1crn0xrep349j">{productShortName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-150" data-mp="25fisyitbk7zz">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-151" data-mp="20h90wh2w5nil">
                <span className="text-sm text-muted" data-id="element-152" data-mp="1vgl7jor6wul7">
                  Regular price: <span className="line-through decoration-electric decoration-2" data-id="element-153" data-mp="1rfrk0whnthsu">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-electric" data-id="element-154" data-mp="k2g2stj5kgot">Today:</p>
                <p className="mt-1 whitespace-nowrap font-display text-6xl font-extrabold leading-none tracking-tight text-gold sm:text-7xl" data-id="element-155" data-mp="g0cm9qhmmlwo">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-156" data-mp="mhe636xwkdvy">
              Get my professional edition now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-muted" data-id="element-157" data-mp="cioqjkthb5iv">
              <span className="inline-flex items-center gap-1.5" data-id="element-158" data-mp="3uw4kehpgo0hs">
                <LockIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-159" data-mp="3uutjcpneh6ud" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-160" data-mp="3kyi1lk51josj">
                <ZapIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-161" data-mp="3l0bbr9ev4r5a" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-162" data-mp="3pv8iuasl0qfj">
                <ShieldCheckIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-163" data-mp="3bybv4i7rfp2v" /> 7-day guarantee
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}